import { FormattedMessage } from "react-intl";
import darkPixiIcon from "src/pages/Welcome/images/dark-pixi-icon.svg";
import pixiDeviceImage from "./assets/pixi-device.svg";
import {
  BannerContent,
  BannerImage,
  BannerText,
  BannerWrapper,
  PixiInlineLogo,
} from "./styles";

export interface EligibilityBannerProps {
  count: number;
}

const pixiLogoElement = (
  <PixiInlineLogo
    src={darkPixiIcon}
    alt="PIXI"
    data-testid="eligibility-banner-pixi-logo"
  />
);

export const EligibilityBanner = ({ count }: EligibilityBannerProps) => (
  <BannerWrapper data-testid="eligibility-banner">
    <BannerContent>
      <BannerText>
        <span data-testid="eligibility-banner-message">
          <FormattedMessage
            id="pixi_wizard.screens.eligibility"
            defaultMessage="{count, plural, one {You are eligible for 1 free {pixiLogo} device or discount!} other {You are eligible for # free {pixiLogo} devices or discount!}}"
            values={{ count, pixiLogo: pixiLogoElement }}
          />
        </span>
        <span data-testid="eligibility-banner-subtitle">
          <FormattedMessage
            id="pixi_wizard.screens.eligibility_subtitle"
            defaultMessage="You can choose this in the Step 3."
          />
        </span>
      </BannerText>
      <BannerImage
        src={pixiDeviceImage}
        alt=""
        data-testid="eligibility-banner-device"
      />
    </BannerContent>
  </BannerWrapper>
);
